import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsSort } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import SelectWrapper from '~/components/forms/SelectWrapper';
import { cn } from '~/helpers/utils';

export interface Option {
  label: string;
  value: string;
  disabled?: boolean;
}

interface SelectProps {
  id?: string;
  options: Option[];
  iconImg?: string;
  initialSelectedValue?: number | string;
  onSelect: (selectedValue: string) => void;
  addedInputStyle?: string;
  addedStyle?: string;
}

const SelectOption: React.FC<SelectProps> = (props) => {
  const {
    options,
    iconImg,
    initialSelectedValue,
    onSelect,
    addedInputStyle = '',
    addedStyle = '',
  } = props;
  const [selectedOption, setSelectedOption] = useState<number | string>(
    initialSelectedValue || ''
  );

  useEffect(() => {
    setSelectedOption(initialSelectedValue || '');
  }, [initialSelectedValue]);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    setSelectedOption(
      isNaN(parseInt(selectedValue)) ? selectedValue : parseInt(selectedValue)
    );
    onSelect(selectedValue);
  };
  return (
    <SelectWrapper className={addedStyle}>
      {iconImg && (
        <FontAwesomeIcon
          icon={faBarsSort as IconProp}
          className="text-lg accent-color h-4 absolute pointer-events-none top-1/2 -translate-y-1/2 left-3"
        />  
      )}
      <select
        id={props.id}
        className={cn(
          'form-input',
          iconImg ? 'px-10' : 'pr-10',
          addedInputStyle,
        )}
        value={selectedOption}
        onChange={handleChange}
      >
        {options.map((option: Option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </SelectWrapper>
  );
};

export default SelectOption;
